function NumberOrNull(value) {
  if (value === '') {
    return null;
  }
  return Number(value);
}

export default NumberOrNull;
